import React, { useState } from "react";
import "./Get_Quote.css";
import Submit_Btn from "../../../common_components/common_btn/submit_btn/Submit_Btn";
import Build_With_Us_Modal from "../../../common_components/common_modal/build_with_us_modal/Build_With_Us_Modal";
// import Get_quote_modal from "../../../common_components/modals/get-quote-modal/Get_quote_modal";

const Get_Quote = (props) => {
  const [quoteModal, setQuoteModal] = useState(false);

  return (
    <>
      <div className="container">
        <section className="Get_Quote">
          <div className="row">
            <div className="col-lg-8 my-auto">
              <p className="quotep">{props.quotetext}</p>
              <Submit_Btn
                btn_name={"Get a Quote"}
                onClick={() => setQuoteModal(true)}
              />
            </div>
          </div>
        </section>
      </div>

      <Build_With_Us_Modal show={quoteModal} onHide={() => setQuoteModal(false)} />
    </>
  );
};

export default Get_Quote;
